function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Presentation");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "layer2",
  d: "M60 39h-2V11H6v28H4a2 2 0 0 0 0 4h23.5l-13 14.7a2 2 0 1 0 3 2.7L30 46.3V61a2 2 0 1 0 4 0V46.3l12.5 14a2 2 0 1 0 3-2.7L36.5 43H60a2 2 0 0 0 0-4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "layer1",
  d: "M6 1h52v6H6z"
});

var SvgPresentation = function SvgPresentation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    "aria-labelledby": "title",
    "aria-describedby": "desc",
    role: "img",
    fill: "currentColor",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPresentation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/presentation.1b19a0ec.svg";
export { ForwardRef as ReactComponent };